import React from "react"
import "../Sass/socialicon.css"

const insta =
  "https://www.instagram.com/invites/contact/?i=twcwnm6k8m3k&utm_content=3knc3bx"

const linkedin = "https://www.linkedin.com/in/hardik-thakor-1a97a61a4"

const github = "https://github.com/hardik239"

const SocialIcon = () => {
  return (
    <div className="social__menu mx-auto">
      <ul>
        <li>
          <a href={github} target="_blank" rel="noopener noreferrer">
            <i className="fab fa-github"></i>
          </a>
        </li>
        <li>
          <a href={insta} target="_blank" rel="noopener noreferrer">
            <i className="fab fa-instagram"></i>
          </a>
        </li>
        <li>
          <a href={linkedin} target="_blank" rel="noopener noreferrer">
            <i className="fab fa-linkedin-in"></i>
          </a>
        </li>
      </ul>
    </div>
  )
}

export default SocialIcon
